import api from "PFCore/api";

export type SendMessagePayload = {
  attachmentIds: number[];
  plain: string;
  conversationId: number;
  profileId: number;
  timeAgo: string;
  localTimestamp: number;
};

export type SendMessageResponse = {
  message: string;
};

export const sendMessage = ({
  attachmentIds,
  plain,
  conversationId,
  profileId,
  timeAgo,
  localTimestamp
}: SendMessagePayload): Promise<SendMessageResponse> =>
  api({
    url: "chat/messages",
    method: "POST",
    data: {
      attachmentIds,
      plain,
      conversationId,
      profileId,
      timeAgo,
      localTimestamp
    }
  });
